import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/**
 * `/$tenant/endpoints` — entrée « Endpoints » hors projet : redirige vers
 * `/$tenant/projects/$projectId/endpoints` (un endpoint est porté par un projet au contrat).
 */
export const Route = createFileRoute('/$tenant/endpoints/')({ component: EndpointsRoute });

function EndpointsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="endpoints" crumbs={[{ label: t('nav.items.endpoints') }]}>
      <ProjectResolver tenantId={tenant} section="endpoints" />
    </ConsoleShell>
  );
}
